import React, { useEffect, useState, useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import styled from 'styled-components';
import CryptoJS from 'crypto-js';
import { colorBackgroundBody } from '@/utils/palette';
import { paddingLeft } from '@/utils/directions';
import Layout from '../../../Layout/index';
import Commerce from './Commerce';
import OnLineMarketingDashboard from '../../../Dashboards/OnLineMarketing/index';
import AppDashboard from '../../../Dashboards/App/index';
import BookingDashboard from '../../../Dashboards/Booking/index';
import FitnessDashboard from '../../../Dashboards/Fitness/index';
import UI from './UI';
import Forms from './Forms';
import Tables from './Tables';
import Charts from './Charts';
import Maps from './Maps';
import Account from './Account';
import ECommerce from './ECommerce';
import DefaultPages from './DefaultPages';
import Documentation from './Documentation';
import ConnectWallet from '../../../Dashboards/Wallet/ConnectWallet';
import FinanceDashboard from '../../../Dashboards/Finance';
import Wallet from '../../../Dashboards/Wallet';
import Agent from '../../../Agent';
import Meal from '../../../Admin/Meal';
import Restaurant from '../../../Admin/Restaurant';
import Agents from '../../../Admin/Agent';
import Users from '../../../Admin/UserManager/Users/Index';
import UsersManagement from '../../../Admin/UserManager/UserManagement/Index';
import Booking from '../../../Admin/Booking';
import PendingTable from '../../../Admin/Payment/component/Pending';
import RejectTable from '../../../Admin/Payment/component/Reject';
import ApprovedTable from '../../../Admin/Payment/component/Approved';
import AccessDeniedPage from '../../../Admin/404';
import Trip from '../../../Admin/Trips/Index';
import RequestList from '../../../Agent/RequestList';
import RejectedRequest from '../../../Agent/RejectRequestTab/RejectedRequest';
import Request from '../../../Agent/Request';
import RejectRequest from '../../../Agent/RejectRequestTab/RejectRequest';
import RequestLists from '../../../Admin/Restaurant/component/RequestList';
import RejectedRequestres from '../../../Admin/Restaurant/component/RejectRequestTab/RejectedRequest';
import { PermissionContext } from '../../../../context/PermissionContext';
import RequestListMeal from '../../../Admin/Meal/component/Request/RequestList';
import { AuthContext } from '../../../../context/AuthContext';
import RejectedRequestMeal from '../../../Admin/Meal/component/RejectRequestTab/RejectedRequest';
import Utility from '../../../Admin/Utility';
import PendingAccount from '../../../Admin/Account/Pending';
import ApprovedAccount from '../../../Admin/Account/Approved';
import RejectAccount from '../../../Admin/Account/Rejected';
import OverallAccount from '../../../Admin/Account/Overall';
import PendingApproval from '../../../Admin/Account/PendingApproval';
import OverallFixAccount from '../../../Admin/OverallFixAccount';
import Currency from '../../../Admin/Currency';
import Whatsapp from '../../../Admin/WP';
import Logs from '../../../Admin/Logs';

export default () => {
  // const [userID, setUserID] = useState();
  const { userid, setUserId } = useContext(AuthContext);
  const { permissionsAccess } = useContext(PermissionContext);
 

  useEffect(() => {
    // Decrypt and retrieve the user ID from localStorage only once when the component mounts
    const encryptedData = localStorage.getItem('userid');
    if (encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
      const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
      setUserId(decryptedUserId);
    }
  }, []); // Empty dependency array ensures this runs only once


  return (
    <div>
      <Layout />
      <ContainerWrap>
        {/* <Route path="/e_commerce_dashboard" component={Commerce} />
        <Route path="/online_marketing_dashboard" component={OnLineMarketingDashboard} />
        <Route path="/connect_wallet" component={ConnectWallet} />
        <Route exact path="/dashboard" component={AppDashboard} />
        <Route path="/booking_dashboard" component={BookingDashboard} />
        <Route exact path="/finance_dashboard" component={FinanceDashboard} />
        <Route path="/fitness_dashboard" component={FitnessDashboard} />
        <Route path="/ui" component={UI} /> */}
        {/* <Route path="/admin/agentNew" component={Agents} /> */}


        {/* <Route path="/app_dashboard" component={OnLineMarketingDashboard} /> */}
      
        <Route
          path="/admin/agent"
          render={() => (permissionsAccess?.[0]?.master_id === '1'
          && permissionsAccess?.[0]?.view === 1 ? (
            <Agent />
          ) : (
            <AccessDeniedPage />
          ))}
        />
        <Route
          path="/admin/agentrequest"
          render={() => (permissionsAccess?.[0]?.master_id === '1'
          && permissionsAccess?.[0]?.view === 1 ? (
            <Request />
          ) : (
            <AccessDeniedPage />
          ))}
        />
        <Route
          path="/admin/agentRejectedRequest"
          render={() => (permissionsAccess?.[0]?.master_id === '1'
          && permissionsAccess?.[0]?.view === 1 ? (
            <RejectRequest />
          ) : (
            <AccessDeniedPage />
          ))}
        />






        {/* <Route
          path="/admin/agent"
          render={() => (permissionsAccess?.[0]?.master_id === '1'
            && permissionsAccess?.[0]?.view === 1 ? (
              <Agent />
            ) : (
              <AccessDeniedPage />
            ))}
        /> */}
        <Route
          path="/admin/restaurant"
          render={() => (permissionsAccess?.[2]?.master_id === '3'
            && permissionsAccess?.[2]?.view === 1 ? (
              <Restaurant />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/restaurantrequest"
          render={() => (permissionsAccess?.[2]?.master_id === '3'
            && permissionsAccess?.[2]?.view === 1 ? (
              <RequestLists />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/restaurantRejectedRequest"
          render={() => (permissionsAccess?.[2]?.master_id === '3'
            && permissionsAccess?.[2]?.view === 1 ? (
              <RejectedRequestres />
            ) : (
              <AccessDeniedPage />
            ))}
        />

        {/* // meal routes */}
        <Route
          path="/admin/meal"
          render={() => (permissionsAccess?.[1]?.master_id === '2'
            && permissionsAccess?.[1]?.view === 1 ? (
              <Meal />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/mealrequest"
          render={() => (permissionsAccess?.[1]?.master_id === '2'
            && permissionsAccess?.[1]?.view === 1 ? (
              <RequestListMeal />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/mealRejectedRequest"
          render={() => (permissionsAccess?.[1]?.master_id === '2'
            && permissionsAccess?.[1]?.view === 1 ? (
              <RejectedRequestMeal />
            ) : (
              <AccessDeniedPage />
            ))}
        />
       
        <Route
          path="/admin/booking"
          render={() => (permissionsAccess?.[3]?.master_id === '4'
            && permissionsAccess?.[3]?.view === 1 ? (
              <Booking />
            ) : (
              <AccessDeniedPage />
            ))}
        />

        <Route
          path="/admin/payment/pending"
          render={() => (permissionsAccess?.[5]?.master_id === '6'
            && permissionsAccess?.[5]?.view === 1 ? (
              <PendingTable />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/payment/approved"
          render={() => (permissionsAccess?.[5]?.master_id === '6'
            && permissionsAccess?.[5]?.view === 1 ? (
              <ApprovedTable />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/payment/reject"
          render={() => (permissionsAccess?.[5]?.master_id === '6'
            && permissionsAccess?.[5]?.view === 1 ? (
              <RejectTable />
            ) : (
              <AccessDeniedPage />
            ))}
        />

        <Route
          path="/admin/trip"
          render={() => (permissionsAccess?.[6]?.master_id === '7'
    && permissionsAccess?.[6]?.view === 1 ? (
      <Trip />
    ) : (
      <AccessDeniedPage />
    ))}
        />

        <Route
          path="/admin/currency"
          render={() => (userid === '1' ? (
            <Currency />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        {/* <Route path="/admin/currency" component={Currency} /> */}
    

        <Route
          path="/admin/daybook"
          render={() => (permissionsAccess?.[8]?.master_id === '9'
        && permissionsAccess?.[8]?.view === 1 ? (
          <OverallFixAccount />
            ) : (
              <AccessDeniedPage />
            ))}
        />

        {/* {permissionsAccess?.[8]?.master_id === '9'
        && permissionsAccess?.[8]?.view === 1 && (
        <Route path="/admin/daybook" component={OverallFixAccount} /> */}
     

     
        <Route
          path="/admin/account"
          render={() => (permissionsAccess?.[7]?.master_id === '8'
            && permissionsAccess?.[7]?.view === 1 ? (
              <PendingAccount />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/accountapproved"
          render={() => (permissionsAccess?.[7]?.master_id === '8'
            && permissionsAccess?.[7]?.view === 1 ? (
              <ApprovedAccount />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/pendingaccountapproval"
          render={() => (permissionsAccess?.[7]?.master_id === '8'
            && permissionsAccess?.[7]?.view === 1 ? (
              <PendingApproval />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/accountrejected"
          render={() => (permissionsAccess?.[7]?.master_id === '8'
            && permissionsAccess?.[7]?.view === 1 ? (
              <RejectAccount />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/overallaccount"
          render={() => (permissionsAccess?.[7]?.master_id === '8'
            && permissionsAccess?.[7]?.view === 1 ? (
              <OverallAccount />
            ) : (
              <AccessDeniedPage />
            ))}
        />


      

        {/* <Route path="/admin/agent" component={Agent} />
        <Route path="/admin/meal" component={Meal} />
        <Route path="/admin/restaurant" component={Restaurant} />
        <Route path="/admin/booking" component={Booking} /> */}
        {/* <Route path="/admin/payment/pending" component={PendingTable} />
        <Route path="/admin/payment/approved" component={ApprovedTable} />
        <Route path="/admin/payment/reject" component={RejectTable} /> */}
        {/* <Route path="/usermanager/users" component={Users} /> */}
       

        <Route
          path="/usermanager/users"
          render={() => (userid === '1' ? (
            <Users />
            ) : (
              <AccessDeniedPage />
            ))}
        />

        <Route
          path="/usermanager/management"
          render={() => (userid === '1' ? (
            <UsersManagement />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route
          path="/admin/utility"
          render={() => (userid === '1' ? (
            <Utility />
            ) : (
              <AccessDeniedPage />
            ))}
        />

        {/* <Route path="/admin/utility" component={Utility} /> */}

        <Route
          path="/admin/wpsetting"
          render={() => (userid === '1' ? (
            <Whatsapp />
            ) : (
              <AccessDeniedPage />
            ))}
        />
        <Route path="/admin/logs" component={Logs} />
        {/* <Route path="/admin/wpsetting" component={Whatsapp} /> */}

        {/* Catch-all 404 route */}
        <Route path="/404" component={AccessDeniedPage} />
        

        {/* <Route path="/usermanager/management" component={UsersManagement} /> */}
        {/* <Route path="/forms" component={Forms} />
        <Route path="/tables" component={Tables} />
        <Route path="/charts" component={Charts} />
        <Route path="/maps" component={Maps} />
        <Route path="/account" component={Account} />
        <Route path="/e-commerce" component={ECommerce} />
        <Route path="/default_pages" component={DefaultPages} />
        <Route path="/documentation" component={Documentation} />
        <Route path="/wallet" component={Wallet} /> */}
      </ContainerWrap>
    </div>
  );
};

// region STYLES

const ContainerWrap = styled.div`
  padding-top: 90px;
  min-height: 100vh;
  transition: padding-left 0.3s;

  ${paddingLeft}: 0;

  background: ${colorBackgroundBody};

  @media screen and (min-width: 576px) {
    ${paddingLeft}: 250px;
  }

  @media screen and (max-width: 576px) {
    padding-top: 150px;
  }
`;

// endregion
